import netsPhone from './nets-phone';
import moduleConfig from './module-config';

export default angular
  .module('app.phone', [])
  .config(['$stateProvider', moduleConfig])
  .component('netsPhone', netsPhone);
